/* This file is based on `vscode-lean4/src/config.ts` */
export function getElaborationDelay() {
    return 200;
}
